import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {Refine} from '@refinedev/core'
import {authProvider} from '@taruvi/refine-providers'
import {taruviClient} from './taruviClient.ts'
import App from './App.tsx'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Refine authProvider={authProvider(taruviClient)}>
      <App/>
    </Refine>
  </StrictMode>
)
